module.exports = __webpack_public_path__ + "img/empty-content.e6114461.svg";